// firmenGesellschafterArt.ts — Firma als schlichte Gesellschafterin aus dem
// Register bzw. der Verflechtung (Paket A4, User 02.10.2026).
//
// Zwischen zwei Firmen gibt es keine „Gesellschafter"-Kante mehr. Hält eine
// Gesellschaft schlicht Anteile (ohne Organfunktion wie Komplementärin oder
// Kommanditistin), wählt der Anwender im Prüfen-Schritt die Art: Mutterfirma
// oder Beteiligung. Keine Vorauswahl und keine Automatik nach der Quote — ohne
// Wahl lässt sich nicht übernehmen (der Server verbindet dann auch nichts).
// Gegenstück im Backend: apps/api/src/firmendaten/registerRollen.ts.

export const FIRMEN_ROLLEN = ["Mutterfirma", "Beteiligung"] as const;
export type FirmenRolle = (typeof FIRMEN_ROLLEN)[number];

/** Beschriftungen im Dialog — mit Richtung, die Nutzer arbeiten ohne Technikwissen. */
export const FIRMEN_ROLLE_LABEL: Record<FirmenRolle, string> = {
  Mutterfirma: "Mutterfirma (diese Firma gehört dazu)",
  Beteiligung: "Beteiligung (hält Anteile an dieser Firma)",
};

/** Hinweis, solange für eine Gesellschaft noch keine Art gewählt ist. */
export const FIRMEN_ROLLE_HINWEIS =
  "Bitte für jede beteiligte Gesellschaft die Art wählen: Mutterfirma oder Beteiligung.";

/**
 * Braucht dieser Eintrag eine gewählte Art? Nur eine Gesellschaft, die als
 * schlichte Gesellschafterin verbunden würde — mit Organfunktion
 * (Komplementärin, Kommanditistin …) bleibt es bei der Rolle.
 */
export const firmenRolleNoetig = (e: {
  art: string;
  beziehungstyp?: string | null;
  funktion?: string | null;
}): boolean => e.art === "organisation" && e.beziehungstyp === "Gesellschafter" && !(e.funktion ?? "").trim();

export const istFirmenRolle = (v: unknown): v is FirmenRolle =>
  typeof v === "string" && (FIRMEN_ROLLEN as readonly string[]).includes(v);
